import { get as lodashGet } from "lodash-es";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

/**
 * Hooks to check if the data objects feature is enabled
 *
 * @returns {boolean} - True if the data objects feature is enabled, false otherwise
 */
export const useEnableDataObjects = (): boolean => {
  const { data: config } = useInstanceConfigQuery();
  return lodashGet(
    config,
    "feature_toggles.STANDARD_DATA_MODEL_FEATURE_TOGGLE",
    false
  );
};
